/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import exportModal from 'shared/ui/mixins/common/export-modal.js';

const __vue_script__ = {
    name: 'ExportPdfAnnotationsModal',

    mixins: [exportModal],

    props: {
        event: {
            type: Object,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },

        docId: {
            type: String,
            required: true,
        },
    },
    async created() {
        try {
            const { attachment, annotations } = await this.$services.appScripts.callAppScript(this.event._id, 'pdf-annotations/export-annotation-data', { id: this.docId });

            const { data: { pdf: base64Pdf } } = await this.$services.pdf.annotateAsset(this.event._id, attachment.pdfAttachmentId, {
                annotations,
                attachment,
            });

            if (!base64Pdf) {
                throw new Error('No PDF returned from annotateAsset');
            }

            const firstDotIdx = attachment.pdfAttachmentId.indexOf('.');
            const filename = attachment.pdfAttachmentId.substring(firstDotIdx + 1);
            this.downloadFile(`${filename}.pdf`, base64Pdf, 'application/pdf');
        } catch (e) {
            return this.$notify({
                group: 'flashes',
                title: this.$i18n.t('general.error_occurred').toString(),
                text: this.$i18n.t('pdf_annotations.export.unable_to_finish_export').toString(),
                type: 'error',
            });
        } finally {
            await this.$emit('close');
        }
    },

    methods: {
        downloadFile(fileName, base64, fileFormat) {
            const linkSource = `data:${ fileFormat };base64,${ base64 }`;
            const a = document.createElement('a');
            a.href = linkSource;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic-export-modal modal-wrapper",class:{ polling: _vm.polling }},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"modal-body"},[(!_vm.error && !_vm.showDownloadButton)?[_c('p',[_vm._v(_vm._s(_vm.$t('listings.messages.preparing_export')))]),(_vm.polling)?_c('progress-bar',{attrs:{"progress":_vm.progress}}):_vm._e()]:_vm._e(),(_vm.error)?[_c('div',{staticClass:"alert alert-error"},[(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_c('p',[_vm._v(_vm._s(_vm.$t('general.try_later')))])])]:_vm._e(),(_vm.showDownloadButton)?[_c('div',{staticClass:"download-link-wrapper"},[_c('p',[_vm._v(_vm._s(_vm.$t('general.could_not_download')))]),_c('a',{ref:"downloadLink",staticClass:"btn btn-primary",attrs:{"href":_vm.downloadPath,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('analytics.exports.download')))])])]:_vm._e()],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ExportPdfAnnotationsModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__